<template>
  <div class="card card-custom ">
    <slot/>
  </div>
</template>

<script>
export default {
  props: ['header']
}
</script>

<style lang="scss" scoped>
.card-custom {
  box-shadow: 0 3px 6px rgba(0,0,0,.15), 0 2px 4px rgba(0,0,0,.12);
  height: 20rem;
}
</style>
